import { BlurRadius, RenderingType } from '@vonage/ml-transformers';
import getDefaultConfig from './getDefaultConfig';
import env from '../../../helpers/env';

const defaultBlurRadius = BlurRadius.High;

const isValidBlurStrength = blurStrength =>
  blurStrength === 'low' || blurStrength === 'high';

const toBlurRadius = blurStrength =>
  (blurStrength === 'low' ? BlurRadius.Low : BlurRadius.High);

const isValidConfig = (config) => {
  if (config?.type !== 'backgroundBlur') {
    return false;
  }

  // blurStrength is optional.  If defined, then make sure it's valid.
  const { blurStrength } = config;
  return blurStrength ? isValidBlurStrength(blurStrength) : true;
};

const BackgroundBlurConfig = {
  isValidConfig,
  getConfig: (opt = {}) => {
    const config = {
      ...getDefaultConfig(opt),
      transformerType: 'BackgroundBlur',
      radius: defaultBlurRadius,
    };

    if (env.isSafari || env.isIosWebView) {
      config.renderingOptions.type = RenderingType.WEBGL;
    }

    const { blurStrength } = opt;

    if (isValidBlurStrength(blurStrength)) {
      config.radius = toBlurRadius(blurStrength);
    }

    return config;
  },
};

export default BackgroundBlurConfig;
